import { journeyAction, } from './base';

import { JourneyActionVoiceSayAlpha as JourneyActionVoiceSayAlphaBase, } from 'atlas-shared';

export const JourneyActionVoiceSayAlpha = journeyAction({
  ...JourneyActionVoiceSayAlphaBase,
  icon: 'Voice',
});
